import{mitzvahSections,weddingSections}from'../data';
import{timelineDefaults}from'../data/timelineDefaults';

const grandEntranceEventTypes=[
  'Bar Mitzvah',
  'Bat Mitzvah',
  'Bar/Bat Mitzvah'
];

const mitzvahEventTypes=[
  'Bar Mitzvah',
  'Bat Mitzvah',
  'Bar/Bat Mitzvah'
];

const mitzvahLineDanceOptions=[
  'Cha Cha Slide',
  'Cupid Shuffle',
  'Macarena',
  'YMCA',
  'Wobble',
  'Crank That',
  'Whip Nae Whip',
  'Electric Slide',
  'Jerusalema',
  'Other'
];

const eventTimingQuestions=[
  {
    id:'eventDescription',
    title:'Event Description,Details and Specifications',
    type:'Long text',
    required:false,
    visible:true,
    options:[]
  },
  {
    id:'eventDuration',
    title:'Event Duration',
    type:'Short text',
    required:false,
    visible:true,
    options:[]
  },
  {
    id:'eventStartTime',
    title:'Event Start Time',
    type:'Time',
    required:false,
    visible:true,
    options:[]
  },
  {
    id:'setupStartTime',
    title:'Setup Start Time',
    type:'Time',
    required:false,
    visible:true,
    options:[]
  },
  {
    id:'eventEndTime',
    title:'Event End Time',
    type:'Time',
    required:false,
    visible:true,
    options:[]
  }
];

const legacyTimingQuestionIds=new Set([
  'start',
  'setup',
  'end'
]);

const candleLightingSection={
  id:'candle-lighting',
  title:'Candle Lighting',
  description:'Plan the thirteen candle-lighting introductions and songs.',
  enabled:true,
  questions:[]
};

const mitzvahGamesSection={
  id:'mitzvah-games-activities',
  title:'Games and Activities',
  description:'Choose the games and activities that should be included at the celebration.',
  enabled:true,
  questions:[
    {
      id:'mitzvahGames',
      title:'Choose games',
      type:'Multiple select',
      required:false,
      visible:true,
      options:[
        'Cock and Pepsi',
        'Limbo',
        'Catch the Cup',
        'Scavenger Hunt',
        'Musical Chairs',
        'Balloon Blow-Up',
        'Group Dance Contest',
        'Trivia',
        'Other'
      ]
    },
    {
      id:'games',
      title:'Would you like games or contests?',
      type:'Single select',
      required:false,
      visible:true,
      options:[
        'Specific time',
        'Throughout the event',
        'No games'
      ]
    }
  ]
};

const musicEditorQuestions=[
  {
    id:'songRequestsTable',
    title:'Song Requests',
    type:'Custom text block',
    required:false,
    visible:true,
    options:[],
    help:'Manage the client song request table.',
    placeholder:'Song title,artist,priority,and dedication or notes.'
  },
  {
    id:'playlistLinks',
    title:'Playlist Links',
    type:'Custom text block',
    required:false,
    visible:true,
    options:[],
    help:'Collect playlist links for cocktail hour,dinner,dancing,and other event moments.',
    placeholder:'Paste YouTube,Spotify,or Apple Music playlist links.'
  }
];

function cloneSections(source=[]){
  return source.map((section)=>({
    ...section,
    questions:(section.questions||[]).map((question)=>({
      ...question,
      options:Array.isArray(question.options)
        ?[...question.options]
        :[],
      fields:Array.isArray(question.fields)
        ?question.fields.map((field)=>({
          ...field,
          options:Array.isArray(field.options)
            ?[...field.options]
            :[]
        }))
        :question.fields
    }))
  }));
}

function cloneQuestions(questions){
  return cloneSections([{questions}])[0].questions;
}

function createCandleQuestions(){
  return Array.from({length:13},(_,index)=>({
    id:`candle-lighting-${index+1}`,
    title:`Candle ${String(index+1).padStart(2,'0')} — Name,introduction,and music`,
    type:'Repeating fields',
    required:false,
    visible:true,
    options:[],
    fields:[
      {
        id:'name',
        label:'Name',
        type:'Short text',
        required:false,
        options:[]
      },
      {
        id:'introduction',
        label:'How to Introduce',
        type:'Long text',
        required:false,
        options:[]
      },
      {
        id:'music',
        label:'Music',
        type:'Song entry',
        required:false,
        options:[]
      }
    ],
    help:'Add the participant name,introduction wording,and music.'
  }));
}

function createGrandEntranceQuestions(){
  return[
    'Grandparents',
    'Parents',
    'Siblings',
    'Bar/Bat Mitzvah',
    'Other'
  ].map((label,index)=>({
    id:`grand-entrance-${index+1}`,
    title:`${label} — Name,introduction,and music`,
    type:'Repeating fields',
    required:false,
    visible:true,
    options:[],
    fields:[
      {
        id:'name',
        label:'Name',
        type:'Short text',
        required:false,
        options:[]
      },
      {
        id:'introduction',
        label:'How to Introduce',
        type:'Long text',
        required:false,
        options:[]
      },
      {
        id:'music',
        label:'Music',
        type:'Song entry',
        required:false,
        options:[]
      }
    ],
    help:'Add the names,introductions,and entrance music in order.'
  }));
}

function createTimelineQuestions(){
  return timelineDefaults.map((moment)=>({
    id:`timeline-${moment.id}`,
    title:moment.name,
    type:'Custom text block',
    required:false,
    visible:true,
    options:[],
    help:moment.description||'',
    placeholder:'Add time,people,music,and production notes.'
  }));
}

function ensureEventTimingQuestions(section){
  if(section.id!=='event'){
    return section;
  }

  const existingIds=new Set(
    (section.questions||[]).map((question)=>question.id)
  );

  const existingTitles=new Set(
    (section.questions||[]).map((question)=>
      String(question.title||'').trim().toLowerCase()
    )
  );

  const cleanedQuestions=(section.questions||[]).filter((question)=>{
    if(legacyTimingQuestionIds.has(question.id)){
      return false;
    }

    const normalizedTitle=String(
      question.title||''
    ).trim().toLowerCase();

    return ![
      'setup start time',
      'event end time'
    ].includes(normalizedTitle)||[
      'setupStartTime',
      'eventEndTime'
    ].includes(question.id);
  });

  const missingQuestions=eventTimingQuestions
    .filter((question)=>
      !existingIds.has(question.id)&&
      !existingTitles.has(question.title.toLowerCase())
    )
    .map((question)=>({...question}));

  return{
    ...section,
    questions:[...cleanedQuestions,...missingQuestions]
  };
}

function ensureMusicEditorQuestions(section){
  if(section.id!=='music'){
    return section;
  }

  const existingIds=new Set(
    (section.questions||[]).map((question)=>question.id)
  );

  const missingQuestions=musicEditorQuestions.filter(
    (question)=>!existingIds.has(question.id)
  );

  return missingQuestions.length===0
    ?section
    :{
      ...section,
      questions:[
        ...(section.questions||[]),
        ...cloneQuestions(missingQuestions)
      ]
    };
}

function ensureSpecialEditorQuestions(section){
  if(
    section.id==='candle-lighting'&&
    (!Array.isArray(section.questions)||section.questions.length===0)
  ){
    return{
      ...section,
      questions:createCandleQuestions()
    };
  }

  if(
    section.id==='ceremony'&&
    (!Array.isArray(section.questions)||section.questions.length===0)
  ){
    return{
      ...section,
      questions:createGrandEntranceQuestions()
    };
  }

  return section;
}

function uniqueSections(sections){
  const seen=new Set();

  return sections.filter((section)=>{
    if(seen.has(section.id)){
      return false;
    }

    seen.add(section.id);
    return true;
  });
}

function isMitzvahEvent(type){
  return mitzvahEventTypes.includes(type);
}

function shouldUseGrandEntrance(type){
  return grandEntranceEventTypes.includes(type);
}

function insertBefore(sections,section,targetId){
  if(sections.some((item)=>item.id===section.id)){
    return sections;
  }

  const index=sections.findIndex(
    (item)=>item.id===targetId
  );

  if(index<0){
    return[...sections,section];
  }

  return[
    ...sections.slice(0,index),
    section,
    ...sections.slice(index)
  ];
}

function customizeSections(sections,eventType){
  let result=uniqueSections(sections)
    .map(ensureEventTimingQuestions)
    .map(ensureMusicEditorQuestions)
    .map(ensureSpecialEditorQuestions)
    .map((section)=>{
      if(section.id==='timeline'){
        return{
          ...section,
          questions:createTimelineQuestions()
        };
      }

      if(
        section.id==='reception'&&
        isMitzvahEvent(eventType)
      ){
        return{
          ...section,
          description:'Grand Entrance and Traditions'
        };
      }

      if(
        section.id==='ceremony'&&
        shouldUseGrandEntrance(eventType)
      ){
        return{
          ...section,
          title:'Reception Grand Entrance',
          description:'Plan the reception grand entrance and entrance songs.',
          questions:section.questions.length
            ?section.questions
            :createGrandEntranceQuestions()
        };
      }

      if(
        section.id==='special'&&
        isMitzvahEvent(eventType)
      ){
        return{
          ...section,
          questions:section.questions.filter(
            (question)=>question.id!=='games'
          )
        };
      }

      if(
        section.id==='music'&&
        isMitzvahEvent(eventType)
      ){
        return{
          ...section,
          questions:section.questions.map((question)=>{
            if(question.id!=='lineDances'){
              return question;
            }

            return{
              ...question,
              options:[
                ...new Set([
                  ...(question.options||[]),
                  ...mitzvahLineDanceOptions
                ])
              ]
            };
          })
        };
      }

      return section;
    });

  if(shouldUseGrandEntrance(eventType)){
    const musicIndex=result.findIndex(
      (section)=>section.id==='music'
    );

    if(
      musicIndex>=0&&
      !result.some((section)=>section.id===candleLightingSection.id)
    ){
      result=[
        ...result.slice(0,musicIndex+1),
        {
          ...candleLightingSection,
          questions:createCandleQuestions()
        },
        ...result.slice(musicIndex+1)
      ];
    }
  }

  if(isMitzvahEvent(eventType)){
    result=insertBefore(
      result,
      mitzvahGamesSection,
      'candle-lighting'
    );
  }

  return uniqueSections(result);
}

export function getQuestionnaireSections(eventType='Wedding'){
  const source=isMitzvahEvent(eventType)
    ?mitzvahSections
    :weddingSections;

  return customizeSections(
    cloneSections(source),
    eventType
  );
}

export function getClientQuestionnaireSections(
  sections,
  eventType='Wedding'
){
  return customizeSections(
    cloneSections(sections),
    eventType
  );
}

export function normalizeQuestionnaireSections(
  sections,
  eventType='Wedding'
){
  return customizeSections(
    cloneSections(sections),
    eventType
  );
}